const DEFAULT_MIN = 0;
const DEFAULT_MAX = Number.MAX_VALUE;

/**
 * Checks if n is between start and up to, but not including, end. If end is not specified,
 * it's set to start with start then set to 0.
 * If start is greater than end the params are swapped to support negative ranges.
 * @export
 * @param {number} number     The number to check.
 * @param {number} [from=0]   The start of the range.
 * @param {number} [to]       The end of the range.
 * @returns {Boolean}  Returns true if number is in the range, else false.
 */
export default function inRange(number, from = DEFAULT_MIN, to = DEFAULT_MAX) {
   return number >= from && number < to;
}
